if (!customElements.get('custom-validate-form')) {
  const selectors = {
    formSelector: 'form',
    DATA_SUBMIT_DELAY: 'data-submit-delay'
  }

  const settings = {
    errorFieldCssClass: 'is-invalid',
    errorLabelCssClass: 'input-error',
    errorLabelStyle: {
      color: '#881616'
    },
    focusInvalidField: true,
    lockForm: false
  }

  const allRules = {
    email: {
      rule: 'email',
      errorMessage: 'Email is invalid!'
    },
    number: {
      rule: 'number'
    }
  }

  class CustomValidateForm extends HTMLElement {
    constructor() {
      super()

      this.attachEvents()
    }

    attachEvents() {
      const forms = this.querySelectorAll(selectors.formSelector)
      const submitDelay = this.hasAttribute(selectors.DATA_SUBMIT_DELAY)
      if (forms.length && !submitDelay) {
        forms.forEach((form) => {
          if (form) {
            const validate = this.initValidate(form)
            if (!validate) return
            validate.onSuccess((event) => {
              form.submit(event)
            })
          }
        })
      }
    }

    initValidate(formEl, callback = false) {
      const formId = `form#${formEl.id}`
      const inputs = Array.prototype.slice.call(formEl.querySelectorAll('input:not([type=hidden]), select, textarea'))
      if (inputs.length) {
        const validate = new window.JustValidate(formId, settings)
        const newRules = inputs.map((input) => this.getValidateRule(input))
        newRules.forEach((rule) => rule.rules.length > 0 && validate.addField(rule.id, rule.rules))

        if (!callback) {
          validate.onSuccess((event) => {
            if (formEl.onsubmit) {
              formEl.onsubmit(event)
            }
          })
        }
        return validate
      }
    }

    addRuleConfirm(rules, input) {
      const confirmField = input.getAttribute('data-confirm')
      const confirmMessage = input.getAttribute('data-confirm-message')
      if (confirmField && confirmMessage) {
        rules.push({
          validator: (value, fields) => {
            if (fields[confirmField] && fields[confirmField].elem) {
              const confirmFieldValue = fields[confirmField].elem.value
              return value === confirmFieldValue
            }
            return true
          },
          errorMessage: confirmMessage
        })
      }
      return rules
    }

    getValidateRule(input) {
      const inputName = input.getAttribute('aria-label') || 'Field'
      const rulesData = {
        id: `#${input.id}`,
        rules: []
      }
      if (input) {
        if (input.required) {
          rulesData.rules.push({
            rule: 'required',
            errorMessage: `${inputName} is required`
          })
        }
        if (input.type === 'email') {
          rulesData.rules.push(allRules.email)
        }
        rulesData.rules = this.addRuleConfirm(rulesData.rules, input)
      }
      return rulesData
    }
  }

  customElements.define('custom-validate-form', CustomValidateForm)
}
